import { HelloJSServiceDef } from 'hellojs';
import { getOrigin } from 'owa-url/lib/getOrigin';

let googleConfig: HelloJSServiceDef = {
    name: 'Google',

    oauth: {
        version: 2,
        auth: 'https://accounts.google.com/o/oauth2/auth',
        grant: 'https://accounts.google.com/o/oauth2/token',
    },

    // Refresh the access_token once expired
    refresh: false,

    login: function (p) {
        if (p.qs.response_type.indexOf('code') >= 0) {
            // set access_type to an offline to get code for refresh token
            p.qs.access_type = 'offline';
        }
        if (p.qs.response_type.indexOf('id_token') > -1) {
            p.qs.nonce = parseInt((Math.random() * 1e12).toString(), 10).toString(36);
        }

        if (p.options.force) {
            p.qs.approval_prompt = 'force';
        }

        // Google will redirect the response to the following url.
        // ADPRedirect will then redirect the requests only to set of domains in the allowed list.
        p.qs.redirect_uri = 'https://outlook.office.com/owa/ADPRedirect.aspx';

        // redirect_url in state is used during token redemption. It should match the redirect uri
        p.qs.state.redirect_uri = 'https://outlook.office.com/owa/ADPRedirect.aspx';

        // ADPRedirect.aspx redirects the request to the url in the state.
        // oauthredirect.html has the js to handle the auth code/response from google
        p.qs.state.url = getOrigin() + '/mail/oauthRedirect.html';
    },

    // Authorization scopes
    scope: {},

    scope_delim: ' ',

    // API base URL
    base: 'https://accounts.google.com',
};
export default googleConfig;
